// @flow
import * as React from 'react';
import {useParams} from "react-router-dom";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {BiCubeAlt} from "react-icons/bi";
import {FaCubes} from "react-icons/fa";
import {GiTwoCoins} from "react-icons/gi";
import {TbArrowBadgeLeft, TbSquareRoundedMinus, TbSquareRoundedPlusFilled} from "react-icons/tb";
// import {CiPercent} from "react-icons/ci";
import {useNavigate} from "react-router-dom";


const currencyFormat = Intl.NumberFormat('en-US');
export default function CompanyServices() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [servitorCompany, setServitorCompany] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [cart, setCart] = React.useState([]);

    React.useEffect(() => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let companyID = window.localStorage.getItem("companyID");
        if(companyID !== id) {
            cartItems = null;
        }
        if (cartItems) {
            setCart(cartItems)
        }
        const params = {

        }
        API.getServitorCompany(id , params)
            .then((response) => {
                setServitorCompany(response.data);
                setServices(response.data.services)
                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }, [id]);

    const onPlusClick = (serviceID , price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));

        let count = 1;
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === serviceID);
            if (find_item) {
                count = find_item.number + 1;
                const objIndex = cartItems.findIndex((obj => obj.item === serviceID));
                cartItems[objIndex].number = count;
            } else {
                cartItems.push({'item': serviceID, 'number': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': serviceID, 'number': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("companyID", id);

    }

    const onMinusClick = (serviceID , price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));


        if (cartItems) {
            const find_item = cartItems.find(x => x.item === serviceID);
            if (find_item) {
                const count = find_item.number;
                const objIndex = cartItems.findIndex((obj => obj.item === serviceID));
                if (count > 1) {
                    cartItems[objIndex].number = count - 1;
                } else {
                    cartItems.splice(objIndex, 1)
                }
                setCart(cartItems)
                window.localStorage.setItem("cart", JSON.stringify(cartItems));
            }
        }

    }

    const getItemCartCount = (serviceID) => {
        const find_item = cart.find(x => x.item === serviceID);
        if (find_item) {
            return (find_item.number)
        } else {
            return 0
        }
    }

    const onSearchServices = (event) => {

        setSearch(event.target.value);
        if(event.target.value.length > 3) {
            setIsLoaded(false);
            const params = {
                search : event.target.value
            }
            API.getServitorCompany(id , params)
                .then((response) => {
                    setServitorCompany(response.data);
                    setServices(response.data.services)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else if(event.target.value.length < 1) {
            setIsLoaded(false);
            const params = {
            }
            API.getServitorCompany(id , params)
                .then((response) => {
                    setServitorCompany(response.data);
                    setServices(response.data.services)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }

    }

    const onSelectGroup = (event,gid,) => {
        var items = document.getElementsByClassName('badge-pill');
        for (var i=0; i < items.length; i++) {
            items[i].style.backgroundColor = '#aaa';
        }
        event.target.style.backgroundColor = '#424242'
       // setIsLoaded(false);
            const params = {
                search : search,
                group_id: gid
            }
            API.getServitorCompany(id , params)
                .then((response) => {

                    setServitorCompany(response.data);
                    setServices(response.data.services)
                    setIsLoaded(true);


                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
    }

    const onContinueClick = () => {
        const services = JSON.parse(window.localStorage.getItem("cart"));
        const requestID = JSON.parse(window.localStorage.getItem("requestID"));
        const params = {
            request_id : requestID,
            services
        }
        API.updateRequest(params)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.clear();
                setTimeout (() => {
                    navigate(`/requests/${requestID}`);
                },1500)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title={servitorCompany.title} hasBack={true}/>
            <section className="container-fluid  mt-3 py-3 rtl px-0 mx-0 services-list ">
                <div className="row mx-1 mt-2">
                    <div className="col-6 text-end mt-2 fw-bold">
                        {servitorCompany.title}
                    </div>
                    <div className="col-6 text-start text-small-3 mt-3 text-primary-color">
                       &nbsp;
                    </div>
                    <div className="col-12 mt-2">
                        <div className='bg-custom p-3 my-2 rounded'>
                            <input type="text" className="w-100 rounded border-0 bg-white text-small-3 p-2"
                                   placeholder="جستجوی خدمات بر اساس عنوان"
                                   value={search}
                                   onChange={onSearchServices}
                            />
                        </div>
                    </div>
                </div>
                <div className="row  flex-row flex-nowrap mx-2 overflow-scroll service-group-row"

                >
                    <div className="col-3 badge badge-pill mx-2 service-group-badge "
                         style={{backgroundColor: '#424242'}}
                         onClick={
                             (e) => {
                                 onSelectGroup(e,0);
                             }
                         }
                    >
                        همه
                    </div>
                    {
                       isLoaded && servitorCompany.groups.map(group => {
                                return (
                                    <div className="col-3 badge badge-pill mx-2 service-group-badge " key={group.id}

                                     onClick={
                                         (e) => {
                                             onSelectGroup(e,group.id);

                                         }
                                     }
                                    >
                                        {group.name}
                                    </div>
                                );
                            }
                        )
                    }
                </div>
            </section>

            <section className="container-fluid mx-2 rtl pb-5">
                <div className="row">
                    <div className="col-12  home-separator-text mt-3 border-bottom pb-2">
                        <FaCubes className='mx-2 '/>
                        لیست خدمات
                    </div>
                </div>
                {
                    isLoaded && services.map(service => {
                        const price = service.price *  (1  -  (service.discount_percent / 100))
                            return (
                                <div className="row service-row mx-2 pt-2 px-0 border-bottom " key={service.id}>
                                    <div className="col-12 fw-bolder text-muted  ">
                                        <BiCubeAlt className='ms-2 '/>
                                        {service.title}
                                   {/*     {
                                            service.discount_percent &&
                                            <div className='price float-start'>
                                                 <span className='discount ms-2 px-1'>
                                                      {service.discount_percent}
                                                     <CiPercent />



                                                </span>


                                            </div>
                                        }*/}
                                    </div>
                                    <div className="col-1">
                                        &nbsp;
                                    </div>
                                    <div className="col-11 price-container px-0 mt-2">

                                        {service.price ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    service.discount_percent &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(service.price)}
                                                        &nbsp;
                                                        ریال
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                ریال
                                                &nbsp;
                                                <span className='text-small-3 bg-light text-secondary px-2 rounded '>
                                                    به ازای هر
                                                    &nbsp;
                                                    {
                                                        service.counting_unit.title
                                                    }
                                                </span>
                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                توافقی
                                            </div>
                                        }

                                    </div>
                                    <div className="col-12 px-0 mx-0 mt-3 ">

                                        <div className="add-minus-services text-start">

                                            {
                                                getItemCartCount(service.id) > 0 ?
                                                    <span className="add-service-icon text-secondary "
                                                          onClick={() => {
                                                              onMinusClick(service.id , price);

                                                          }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                getItemCartCount(service.id) > 0 ?
                                            <span className="px-2">
                                    <input type="text" className="bg-white" value={getItemCartCount(service.id)}  readOnly/>
                                </span> : <span>&nbsp;</span>
                                            }

                                            <span className="add-service-icon   "
                                                  onClick={() => {
                                                      onPlusClick(service.id , price);

                                                  }}>
                                         <TbSquareRoundedPlusFilled className='text-success'/>
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    )
                }
                {
                    cart.length > 0 ?
                        <div className="row">
                            <div className="col-12 p-2 fixed-bottom max-w-lg">
                                <button
                                    className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                                    onClick={onContinueClick}
                                >
                                    ادامه
                                    <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                                </button>
                            </div>
                        </div>
                        : ''
                }

            </section>
        </React.Fragment>
    );
}